import styled from 'styled-components';

export const FileUploadIcon = styled.img`
  width: 18px;
  height: 18px;
`;
